module.exports = __webpack_public_path__ + "img/Ching.db06d257.svg";